var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{staticClass:"player-item pl-0"},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline"},[_vm._v("\n      "+_vm._s(((_vm.content.name) + " : " + (_vm.content.value)))+"\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }